import React from 'react'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'

const CustomSelect = ({
  input,
  hideEmpty,
  width,
  onChange,
  label,
  meta,
  options,
  showError,
  ...props
}) => {
  if (!input || !meta) {
    throw Error('Sorry my friend. Did you forget field from final form?')
  }

  const handleChange = event => {
    onChange && onChange(event)
    input.onChange(event)
  }

  const touched = meta.touched || showError

  return (
    <FormControl style={{ width, height: 48 }}>
      <InputLabel htmlFor="age-simple" error={meta.error && touched}>
        {label}
      </InputLabel>
      <Select
        {...props}
        error={meta.error && touched}
        value={input.value}
        onChange={handleChange}
        onBlur={input.onBlur}
      >
        {hideEmpty ? null : (
          <MenuItem value="">
            <em>Vazio</em>
          </MenuItem>
        )}
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText error>{touched && meta.error}</FormHelperText>
    </FormControl>
  )
}

CustomSelect.defaultProps = {
  width: '100%',
  hideEmpty: false
}

export default CustomSelect
